module.exports = __webpack_public_path__ + "img/1080_15.00c32aa7.jpg";